import {
  arrayOf,
  bool,
  number,
  object,
  oneOfType,
  shape,
  string,
} from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors } from "../../../styles/Styles.variables";

import FilestackImage from "../../filestack-image";
import Group from "../../form/components/Group";
import Label from "../../form/components/Label";

const thumbGap = 9;
const thumbGapRem = rem(`${thumbGap}px`);
const thumbSize = 94;

/**
 * Displays selectable grid of listing photos
 *
 * @param {array}    props.photos
 * @param {string}   props.targetDevice
 * @returns JSX
 * @public
 */
const ModalFilesPhotos = ({ photos = [], targetDevice }) => {
  if (!photos || !photos.length) {
    return null;
  }

  return (
    <Group>
      <Label as="p">Photos</Label>
      <ThumbGrid targetDevice={targetDevice}>
        {photos.map((photo, index) => {
          return (
            <li key={`thumb-${photo.fileName}`}>
              <Thumb
                alt={photo.fileTitle}
                handle={photo.fileName}
                height={thumbSize}
                theme="dark"
                width={thumbSize}
              />
            </li>
          );
        })}
      </ThumbGrid>
    </Group>
  );
};

const ThumbGrid = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 0 0 -${thumbGapRem};
  padding: 0;
  width: calc(100% + ${thumbGapRem});

  li {
    display: block;
    margin: 0 0 ${thumbGapRem} ${thumbGapRem};
    width: calc(
      ${({ targetDevice }) =>
          targetDevice === "desktop" ? "16.666666667%" : "25%"} - ${thumbGapRem}
    );
  }
`;

const Thumb = styled(FilestackImage)`
  display: block;

  &[data-status="error"] {
    background-color: ${colors.gray100};
  }
`;

ModalFilesPhotos.propTypes = {
  photos: arrayOf(
    shape({
      fileDate: oneOfType([object, string]),
      fileId: oneOfType([number, string]),
      fileIndex: number,
      fileIsPublic: bool,
      fileName: string,
      fileTitle: string,
      fileType: string,
    })
  ),
  targetDevice: string,
};

export default ModalFilesPhotos;
